/**
 * The device's IANA timezone (for example "Asia/Dubai"), sent with each chat
 * message so the agent's "today" and research time windows are the user's
 * local ones. Undefined when the runtime cannot say; the server then uses UTC,
 * as it does for any value it does not recognise.
 */
export function resolveDeviceTimezone(): string | undefined {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return typeof zone === 'string' && zone.trim() ? zone.trim() : undefined;
  } catch {
    return undefined;
  }
}
